export default {output:'VÝSTUP'};